import copy from '~/components/atoms/a-copy/a-copy.data'

export default {
  ...copy,
  heading: 'How does it work?',
  copy:
    'Working in sprints, a team of developers, designers, creatives and UXers, will work on a strategic brief matching a business problem with either a new technology or one that’s soon to be released. They’ll concept and prototype an innovative idea that answers the brief.\n' +
    '\n' +
    '#### Why are we doing it?\n' +
    '\n' +
    ' - To give the opportunity to evolve and push ourselves, and our client partners, out of comfort zones.\n' +
    ' - To allow experimentation within Tribal with a focus on new technologies and products that are set to change the digital landscape.\n' +
    ' - To share breakthrough knowledge and perspective direct from the hands of our practitioners.\n' +
    ' - To help brands and clients shape their future.',
  cta: [],
  component: 'm-article-text-v2',
}
